export const MODAL_ID = 'modal-quiz'
export const MULTIPLE_CHOICE = 'multipleChoice'
export const OPEN_TEXT = 'openText'